import { render, staticRenderFns } from "./ReviewExerciseGenerateStaff.vue?vue&type=template&id=16e3ab2d"
import script from "./ReviewExerciseGenerateStaff.vue?vue&type=script&lang=js"
export * from "./ReviewExerciseGenerateStaff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports